import React from 'react';
import { Label, } from 'components'
import PropTypes from 'prop-types'
import {
  colors,
} from '@material-ui/core'

const LabelBoolean = (props) => {
  const { value, } = props

  return (
    <Label
      color={value ? colors.green[600] : colors.red[600]}
      variant="outlined"
    >
      {value ? 'Yes' : 'No'}
    </Label>
  )
}

LabelBoolean.propTypes = {
  value: PropTypes.bool,
};

export default LabelBoolean
